import { render, staticRenderFns } from "./OficialesRegistro.vue?vue&type=template&id=30136c81&"
import script from "./OficialesRegistro.vue?vue&type=script&lang=js&"
export * from "./OficialesRegistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports